import { takeLatest, put, call, delay } from 'redux-saga/effects';
import * as type from '../../redux/types/trans';
import Api from '../../services/trans/trans';

let allApi = new Api();


async function fetchUser(data) {
    let res = await allApi.commonGet(data);
    return res;

}

function* fetchData(action) {

    let payload = {
        "apiName": "GetCartDetails",
        "params": ""
    }
    let apiresponse = yield call(fetchUser, payload)

    if (apiresponse.data.success === true) {
        let allData = apiresponse.data.data;

        console.log(allData, 'GetCartDetails')
        yield put({ type: type.GET_CART_SUCCESS, payload: allData })
    } else {
        yield put({ type: type.GET_CART_FAILURE, payload: {} })
    }


}

export function* getCartData() {
    yield takeLatest(type.GET_CART_PENDING, fetchData)
}

export function* getBankData(data) {
    yield put(type.BANK_DETAILS, data)
}

export function* getAmount(data) {
    yield put(type.LUMSUM_AMT, data)
}


export function* saveTrans({ type, resolve, payload }) {
    console.log("In saga", payload)
    let responsePayload = {};
    try {
        let { data } = yield allApi.saveTransaction(payload);

        if (data.success) {
            responsePayload = data.data;
            yield put({ type: type.SAVE_TRANS_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            yield put({ type: type.SAVE_TRANS_RESPONSE_FAILED })
            resolve && resolve(data)
        }
    } catch (e) {

        yield put({ type: type.SAVE_TRANS_RESPONSE_FAILED })
        resolve && resolve()
    }
}

export function* saveTransDetails(data) {
    yield put(type.SAVE_TRANS, data)
}

export function* getParams(data) {
    try{
        yield put(type.GET_PARAMS, data)
    }catch(e){
        
    }
}

export function* paymentRes(data) {
    yield put(type.PAYMENT_RES, data)
}